import React, { Component } from 'react';


class Log extends Component {

    constructor(props) {
        super(props);

        this.state = {
            eventsPartiText: window.localStorage.getItem('dkk-proeve-lydighet-parti-events-' + process.env.REACT_APP_ENV + '-backup')
        }
    }

    render() {
        const { eventsPartiText } = this.state;

        return (
            <div className="container">
                <div><strong>Log med de 2000 sidste events</strong></div>
                <div>
                    {eventsPartiText}
                </div>
            </div>
        );
    }


}
export default Log;





// WEBPACK FOOTER //
// ./src/pages/log/Log.js